import { PaperScope, Size, Raster, Group, Path, Point } from 'paper'
import bus from './bus'
import UI from './utils/UI'
/* eslint-disable */

UI({
  component: '.js-paperTearImage',
  canvasTear: '.js-paperTearImage-canvas',
  image: '.js-paperTearImage-image'
}, ({ canvasTear, image }) => {
  if (!canvasTear || !image) {
    return
  }
  // window.addEventListener("load",function() { changeBackground('red') });
  setTimeout(function () {
    const margin = 5
    const offset = margin / 3
    const stepSize = 3
    const scopeTear = new PaperScope()
    scopeTear.setup(canvasTear)
    scopeTear.view.setViewSize(new Size(canvasTear.clientWidth, canvasTear.clientHeight))
    const raster = new Raster(image)
    raster.visible = false
    raster.onLoad = _ => {
      raster.fitBounds(scopeTear.view.bounds, true)
      raster.position = scopeTear.view.center

      const path = new Path()
      path.closed = true

      const group = new Group([path, raster])
      group.clipped = true

      drawBorders(path, { width: canvasTear.clientWidth, height: canvasTear.clientHeight, margin, offset, stepSize })

      bus.on('window-resize', _ => {
        scopeTear.view.setViewSize(new Size(canvasTear.clientWidth, canvasTear.clientHeight))
        raster.fitBounds(scopeTear.view.bounds, true)
        raster.position = scopeTear.view.center
        drawBorders(path, { width: canvasTear.clientWidth, height: canvasTear.clientHeight, margin, offset, stepSize })
      })
      raster.visible = true
      scopeTear.view.draw()
    }
  }, 600);

})

function drawBorders(path, args)
{
  path.segments = []

  // Top line
  for (let x = args.margin; x <= args.width - args.margin; x += args.stepSize) {
    const y = args.margin + randomOffset(args.offset)
    path.add(new Point(x, y))
  }

  // Right line
  for (let y = args.margin; y <= args.height - args.margin; y += args.stepSize) {
    const x = (args.width - args.margin) + randomOffset(args.offset)
    path.add(new Point(x, y))
  }

  // Bottom line
  for (let x = args.width - args.margin; x >= args.margin; x -= args.stepSize) {
    const y = (args.height - args.margin) + randomOffset(args.offset)
    path.add(new Point(x, y))
  }

  // Left line
  for (let y = args.height - args.margin; y >= args.margin; y -= args.stepSize) {
    const x = args.margin + randomOffset(args.offset)
    path.add(new Point(x, y))
  }
}

function randomOffset(offset)
{
  return (Math.random() * offset * 2) - offset
}
/* eslint-enable */
